/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum ETerraDrawMode {
  Static = 'static',
  Polygon = 'polygon',
  Circle = 'circle',
  Rectangle = 'rectangle'
}